import React from 'react';
import { Link } from 'react-router-dom';
import './dashboard2.css';  

const Dashboard2 = () => {
  return (
    <div>
      <div className="profile">
        <div className="profile-info">
          <h1>Aad van Dam</h1>
          <h2>Beeldhouwer</h2>
          <h3>Werkeiland Lelystad</h3>
          <Link to="/contact" className="contact-btn">Contact</Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard2;
